import { Routes } from '@angular/router';
import { canActivateAuth } from '@core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/initializer/pages/initializer.page').then((m) => m.InitializerPage),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login/pages/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/register/pages/register.page').then((m) => m.RegisterPage),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/forgot-password/pages/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/reset-password/pages/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: 'admin',
    canActivate: [canActivateAuth],
    loadComponent: () =>
      import('@features/dashboard/dashboard-page/dashboard.page').then((m) => m.DashboardPage),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/driver-management/driver-management-page/driver-management.page').then(
            (m) => m.DriverManagementPage,
          ),
      },
      {
        path: 'charges',
        loadComponent: () =>
          import('./features/dashboard/charges/charges-page/charges.page').then(
            (m) => m.ChargesPage,
          ),
      },
      {
        path: 'statements',
        loadComponent: () =>
          import('./features/dashboard/statements/statements-page/statements-page.component').then(
            (m) => m.StatementsPage,
          ),
      },
    ],
  },
  {
    path: 'accept-invite',
    // Do not guard this route: a false canActivate loops / with /accept-invite.
    loadComponent: () =>
      import('./features/accept-invite/pages/accept-invite.page').then((m) => m.AcceptInvitePage),
  },
  { path: 'registration-callback', redirectTo: '' },
  { path: '**', redirectTo: '' },
];
